import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router";
import { useEffect, useRef } from "react";
import { trackPageView } from "./utils/tracking";
import useScrollDepth from "./utils/useScrollDepth";
// import AboutUs from "./routes/AboutUs/AboutUs";
import Services from "./routes/Services/Services";
import MicroneedlingPage from "./routes/Services/MicroneedlingPage";
import AdvancedFacialsPage from "./routes/Services/AdvancedFacialsPage";
import ChemicalPeelsPage from "./routes/Services/ChemicalPeelsPage";
import SkinBoostersPage from "./routes/Services/SkinBoostersPage";
import VitaminInjectionsPage from "./routes/Services/VitaminInjectionsPage";
import SkinConsultationPage from "./routes/Services/SkinConsultationPage";
import Medik8ConsultationPage from "./routes/Services/Medik8ConsultationPage";
import AddOnsPage from "./routes/Services/AddOnsPage";
import Packages from "./routes/Packages/Packages";
import Reviews from "./routes/Reviews/Reviews";
import Gallery from "./routes/Gallery/Gallery";
// import ContactUs from "./routes/ContactUs/ContactUs";
import Home from "./routes/HomePage/Home";
import NavBar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";
import CancellationPolicy from "./Components/CancellationPolicy/CancellationPolicy";
import TermsConditions from "./Components/TermsConditions/TermsConditions";
import PrivacyPolicy from "./Components/PrivacyPolicy/PrivacyPolicy";
import Medik8 from "./routes/Medik8/Medik8";
import Aftercare from "./routes/Aftercare/Aftercare";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    // gtag's initial "config" call in public/index.html already sends one
    // page_view for the hard-loaded URL — only send our own on subsequent
    // in-app navigations, so the first page view isn't double-counted.
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    trackPageView(pathname);
  }, [pathname]);

  useScrollDepth(pathname);

  return null;
};

const PageRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          {/* <Route path="/about" element={<AboutUs />} /> */}
          <Route path="/treatments/microneedling" element={<MicroneedlingPage />} />
          <Route path="/treatments/advanced-facials" element={<AdvancedFacialsPage />} />
          <Route path="/treatments/chemical-peels" element={<ChemicalPeelsPage />} />
          <Route path="/treatments/skin-boosters" element={<SkinBoostersPage />} />
          <Route path="/treatments/vitamin-injections" element={<VitaminInjectionsPage />} />
          <Route path="/treatments/skin-consultation" element={<SkinConsultationPage />} />
          <Route path="/treatments/medik8-consultation" element={<Medik8ConsultationPage />} />
          <Route path="/treatments/add-ons" element={<AddOnsPage />} />
          <Route path="/treatments" element={<Services />} />
          <Route path="/packages" element={<Packages />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/medik8" element={<Medik8 />} />
          <Route path="/aftercare" element={<Aftercare />} />
          <Route path="/cancellation-policy" element={<CancellationPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          {/* <Route path="/contact" element={<ContactUs />} /> */}
        </Routes>
      </main>
      <Footer />
    </Router>
  );
};

export default PageRoutes;
